import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<{ isSubscribed: boolean }>()(
  (theme, { isSubscribed }) => ({
    container: {
      display: "flex",
      width: "100%",
      maxWidth: 605,
      cursor: isSubscribed ? "pointer" : "auto",
      [theme.breakpoints.down("md")]: {
        maxWidth: "calc(100vw - 32px)",
      },
    },
    inspirationImages: {
      display: "flex",
      gap: theme.spacing(1),
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        width: 0,
      },
    },
    inspirationImageContainer: {
      display: "inline-block",
      flex: "0 0 auto",
      position: "relative",
    },
    inPaintIndicator: {
      width: 30,
      height: 30,
      position: "absolute",
      bottom: theme.spacing(1),
      right: theme.spacing(0),
      padding: theme.spacing(1),
      color: "#ffffff",
      background: "rgba(0, 0, 0, 0.5)",
      fontSize: "1.5rem",
      filter: `drop-shadow(0px 0px 1px ${theme.palette.primary.main})`,
      borderRadius: "50%",
    },
    inspirationImage: {
      position: "relative",
      background: "#ececec",
      objectFit: "cover",
      overflow: "hidden",
      borderRadius: "5px",
    },
  })
);
